import {React, useState,useEffect} from 'react';
import { Col, Row, Card, Button } from 'react-bootstrap';
import { PortfolioAPI } from '../API/salesforceAPI';
import { DynamicPortfoliomarketAPI, PortfoliomarketAPI } from '../API/marketingcloudAPI';

import { smartPortfolioAPI } from '../API/smartAPI';
import { technologyPortfolioAPI } from '../API/technologyAPI';
import { cloudPortfolioAPI } from '../API/cloudAPI';
import StayInTouch from '../components/StayInTouch';
import {digitalPortfolioAPI} from '../API/digitalAPI';
import {motion} from "framer-motion";
import OurPortfolio from './OurPortfolio';
import Aos from "aos";
import "aos/dist/aos.css";
import $ from 'jquery';
import Modal from 'react-bootstrap/Modal';
import portfoliobg from '../assets/images/portfolio2_bg.jpg'
import clientLogo from '../assets/images/ClientNamelogo.svg'
import clientlocLogo from '../assets/images/client_location.svg'
import TeamLogo from '../assets/images/team_size.svg'
import PlatformLogo from '../assets/images/platform.svg'
import { commercePortfolioAPI } from '../API/commerceAPI';

const PortfolioGlance = () => {
    const [portfolioTitleData, setPortfolioTitleData] = useState([]);
    const [portfolioContentData, setPortfolioContentData] = useState([]);
    const [listLength, setlistLength] = useState();
    const [visible, setvisible] = useState(6);
    // sep29 -- data fetch popup
    const [dataContent,setdataContent] = useState([]);
    const [tabIndex, settabIndex] = useState();
    const [show, setShow] = useState(false);
    const [title, settitle] = useState([]);
    const [clientName, setclientName] = useState([]);
    const [clientLocation, setclientLocation] = useState([]);
    const [teamCount, setteamCount] = useState([]);
    const [platformtitle, setplatformtitle] = useState([]);
    const [modalData, setModalData] = useState([]);
    const [projDescription, setprojDescription] = useState([]);
    const [bicsDescription, setbicsDescription] = useState([]);
    const [subDescription, setsubDescription] = useState([]);
    const handleShow = () => {
        // setFullscreen(breakpoint);
        setShow(true);
      }
      const tab_title=[];
      const client_title=[];
      const Location_title=[];
      const team_size=[];
      const platform=[];
      const pop_desc=[];
      const bics_desc=[];
      const sub_desc=[];

    const businessTextAnimate={
        offscreen:{y:0, opacity:1},
        onscreen:{
          y:0,
          opacity:1,
          transition:{
          type:"spring",
          ease: "easeInOut",
          bounce:0.4,
          duration:3,
          
          }
        }
      }

  useEffect(() => { 
    Aos.init({ duration: 1000 });
    var config = { "Access-Control-Allow-Origin": "*" }
    //window.location.href.includes('salesforce') === true
    //console.log("world",["salesforce","salescloud","servicecloud","einstein","healthcloud","ecommercecloud"].includes(window.location.href.split('/')[3]))
    if(["salesforce","salescloud","servicecloud","einstein","ecommercecloud","healthcloud"].includes(window.location.href.split('/')[3])){
        console.log("api calling")
        PortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);         
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.split('/')[3]=="ecommerce"){
        //debugger
        DynamicPortfoliomarketAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);            
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            },"getpage5block13"

        );
      }
      else if(window.location.href.split('/')[3]=="mobility"){
        //debugger
        DynamicPortfoliomarketAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);            
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            },"getpage5block14"

        );
      }
 
      else if(window.location.href.split('/')[3]=="technologies"){
        //debugger
        DynamicPortfoliomarketAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);            
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            },"getpage5block15"

        );
      }
      else if(window.location.href.split('/')[3]=="intelligent"){
        //debugger
        DynamicPortfoliomarketAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);            
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            },"getpage5block16"

        );
      }


         else if(window.location.href.includes('marketingcloud') === true){
        PortfoliomarketAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);            
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }

      else if(window.location.href.includes('marketingcloud') === true){
        PortfoliomarketAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);            
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
    //   else if(window.location.href.includes('commerce') === true){
    //     commercePortfolioAPI(config, (response) => {
    //         //success
    //         const portfolioTitle = response.data.map(item => item.contentTitle);
    //         const portfolioElement = response.data.map(item => item.contentElements);
    //         setPortfolioTitleData(portfolioTitle);
    //         setPortfolioContentData(portfolioElement[0]);
            
    //         //console.log("serviceElement", response.data[0].contentElements);
    //         setdataContent(response.data[0].contentElements);
    //         setlistLength(portfolioElement[0].length);
    //         },(err) => {
    //             //error
    //             console.log(err);
    //         });
    //   }
      else if(window.location.href.includes('smart') === true){
        smartPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);
           
          //  console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.includes('analytics') === true){
        smartPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);
           
          //  console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.includes('automations') === true){
        smartPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);
           
          //  console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.includes('devops') === true){
        smartPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);
           
          //  console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.includes('digitalcms') === true){
        digitalPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);          
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.includes('ecommerce') === true){
        digitalPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);          
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.includes('lms') === true){
        digitalPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);          
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.includes('uiux') === true){
        digitalPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);          
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
     

      else if(window.location.href.includes('technologies') === true){
        digitalPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);          
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            setlistLength(portfolioElement[0].length);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.includes('technology') === true){
        technologyPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);
            setlistLength(portfolioElement[0].length);
          //  console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            },(err) => {
                //error
                console.log(err);
            });
      }
      else if(window.location.href.includes('cloud') === true){
        cloudPortfolioAPI(config, (response) => {
            //success
            const portfolioTitle = response.data.map(item => item.contentTitle);
            const portfolioElement = response.data.map(item => item.contentElements);
            setPortfolioTitleData(portfolioTitle);
            setPortfolioContentData(portfolioElement[0]);
            setlistLength(portfolioElement[0].length);
           // console.log("serviceElement", response.data[0].contentElements);
            setdataContent(response.data[0].contentElements);
            },(err) => {
                //error
                console.log(err);
            });
      }
    
      
  }, []);


  const tabselect = (index) => {
    settabIndex(index);
    handleShow(true);
    const seletedData=dataContent[tabIndex];
    setModalData(seletedData);
    for(let i=0;i<dataContent.length;i++)
                {
                    tab_title.push(dataContent[i].ElementProjectName);
                    client_title.push(dataContent[i].ElementClientName);
                    Location_title.push(dataContent[i].ElementClientRegion);
                    team_size.push(dataContent[i].ElementTeamSize);
                    platform.push(dataContent[i].ElementPlatform);
                    pop_desc.push(dataContent[i].ElementDescription);
                    bics_desc.push(dataContent[i].ElementBicsGlobalSolution);
                    // sub_desc.push(dataContent[i].ElementSubDescription);
                    sub_desc.push(dataContent[i].ElementSubDescription.replace(/(<([^>]+)>)/ig, ''));
                    settitle(tab_title);
                    setclientName(client_title);
                    setclientLocation(Location_title);
                    setteamCount(team_size);
                    setplatformtitle(platform);
                    setprojDescription(pop_desc);
                    setbicsDescription(bics_desc);
                    setsubDescription(sub_desc);
                }
  }
  //console.log("data_tab=",tabIndex);
  const seletedData=dataContent[tabIndex];
 // console.log("selected data",modalData);

  if(visible < listLength){
    $('.load_more').show();
}
else{
    $('.load_more').hide();
}
const showMoreItems = () => {
    setvisible((preValue) => preValue + 3 );
  }
 // console.log("listLength",listLength);
  
 // console.log("portfolioContentData",portfolioContentData);
//   setModalData(seletedData);




//   console.log("data_serviceElement",dataContent);
//   for(let i=0;i<dataContent.length;i++)
//                 {
//                     tab_title.push(dataContent[i].ElementProjectName);
//                     // tab_image.push(dataContent[i].ElementLogo);
//                     settitle(tab_title);
//                     // setimage(tab_image);
//                 }
  return (
    <div className='sf_cloud_block'>
        <div className="bics-header-wrapper pt-5">
            <div className="container pb-5">
                <h2 className="bics-header robotoBold mb-4">{portfolioTitleData}</h2>
                {/* <motion.div className='bics-flip-front'
                   initial={"offscreen"} 
                   whileInView={"onscreen"}
                   viewport={{once:false, amount:0.1}}
                   transition={{staggerChildren:0.5}}
                  > */}
                <Row>
                {portfolioContentData.slice(0,visible).map((item, index) => (
                    <Col xl={4} lg={4} md={6} xs={12} className="py-3" key={index}>
                    <Card border="light" className='portfolio_container card_hover'>
                        <div className='bics-portpolio-img'>
                        {/* <motion.div className='bics-animate' variants={businessTextAnimate}> */}
                        <div className='glance_img_section'>
                            <img  src={process.env.REACT_APP_BASE_URL + item.ElementLogo1}
                                className='w-100 glance_image position-relative' 
                                alt="portfolio_img" 
                                data-aos="fade-up"/>
                            <span className="glance_batch" 
                                    data-aos="zoom-out-right"
                                    data-aos-duration="2000">
                                <img src={process.env.REACT_APP_BASE_URL + item.ElementLogo2} height={40} alt="icon_batch" />
                                <span className='innerbatch_text'>{item.ElementTittle1}</span>
                            </span>
                        </div>
                         {/* </motion.div> */}
                         </div>
                        <div className="text-left p-4">
                        <p className='portfolio_title mb-2'>{item.ElementTitle}</p>
                        <p className='portfolio_content'>{item.ElementDescription}</p>
                        <div className='btn_alignmnt'>
                        <StayInTouch className='bluebutton'>{item.ElementActionText}</StayInTouch>
                        {/* <OurPortfolio  className='bluebutton'>View Portfolio</OurPortfolio> */}
                        <span className='job_portal_modal'>
                        <Button className="me-2 mb-2 green_carrer_btn" onClick={() => tabselect(index)}>View Portfolio</Button>
                        </span>
                        </div>
                        {/* <Button variant="primary" className='bluebutton'>{item.ElementActionText}</Button> */}
                        </div>
                       
                    </Card>
                    </Col>
                    
                ))}  
                 <Modal className='modal_portfolio_width px-0' 
      show={show}
       onHide={() => setShow(false)}
       size='xl'>
        <Modal.Header className='ourportfolio_header pop_white' closeButton>
        </Modal.Header>
        <Modal.Body className='d-flex align-items-center pop_white px-0 portfolio_block'> 
            <Col xl={12} md={12} xs={12} className='mx-auto'>
            <h5 className='text-center'>OUR PORTFOLIO</h5>
            <Col xl={10} className='mx-auto px-3'>
            <h5 className='portfolio_title mb-3'>Project Name</h5>
            <h6 className='project_name mb-3'>{title[tabIndex]}</h6>
            </Col>
            <div className="">
            <img src={portfoliobg} alt="portfolio_bg" className='w-100 portfo_project_image'/>
            </div>
            <div className='portfolio_grid py-3'>
                <Col xl={10} className='mx-auto'>
                    <Row>
                    <Col xl={3} md={6} xs={12}> 
                    <Row className="mx-0">
                        <Col xl={3} md={12} xs={12} className='align-self-center'>
                            <img src={clientLogo} className="portfolio-icons" width={40}/>
                        </Col>
                        <Col xl={9} md={12} xs={12} className='height-100px'>
                            <h6 className="port-subhead mt-3">Client Name</h6>
                            <p className="port-sub-detail">{clientName[tabIndex]}</p>
                        </Col>
                    </Row>
                    </Col>
                    <Col xl={3} md={6} xs={12}> 
                    <Row className="mx-0">
                        <Col xl={3} md={12} xs={12} className='align-self-center'>
                            <img src={clientlocLogo} className="portfolio-icons" width={40}/>
                        </Col>
                        <Col xl={9} md={12} xs={12} className="height-100px">
                            <h6 className="port-subhead mt-3">Client Religion</h6>
                            <p className="port-sub-detail">{clientLocation[tabIndex]}</p>
                        </Col>
                    </Row>
                    </Col>
                    <Col xl={3} md={6} xs={12}> 
                    <Row className="mx-0">
                        <Col xl={3} md={12} xs={12} className='align-self-center'>
                            <img src={TeamLogo} className="portfolio-icons" width={40}/>
                        </Col>
                        <Col xl={9} md={12} xs={12} className="height-100px">
                            <h6 className="port-subhead mt-3">Team Size</h6>
                            <p className="port-sub-detail">{teamCount[tabIndex]}</p>
                        </Col>
                    </Row>
                    </Col>
                    <Col xl={3} md={6} xs={12}> 
                    <Row className="mx-0">
                        <Col xl={3} md={12} xs={12} className='align-self-center'>
                            <img src={PlatformLogo} className="portfolio-icons" width={40}/>
                        </Col>
                        <Col xl={9} md={12} xs={12} className="height-100px">
                            <h6 className="port-subhead mt-3">Platform</h6>
                            <p className="port-sub-detail">{platformtitle[tabIndex]}</p>
                        </Col>
                    </Row>
                    </Col>
                    </Row>
                </Col>
            </div>
            <Col xl={10} className='mx-auto px-3'>
                <p className='proj_subtitle mt-3'>Project Objective</p>
                <p className='proj_content'>{projDescription[tabIndex]}</p>
                <p className='proj_subtitle mt-3'>BICSGLOBAL Solution</p>
                <p className='proj_content'>{bicsDescription[tabIndex]}</p>
                <p className='proj_subtitle mt-3'>Project Description</p>
                <div className="port_desc_list">
                {subDescription[tabIndex]}
                </div>
            </Col>
            </Col>
        </Modal.Body>
                </Modal>
                </Row>
                <Button className="load_more" onClick={showMoreItems}>Load More</Button>
                {/* </motion.div> */}
            </div>
        </div>
    </div>
  )
}

export default PortfolioGlance
